import { useQuery } from '@apollo/client';
import { useDialog } from 'components/hooks';
import { ILogItem } from 'designSystem/DataDisplay/LogItem/LogItem';
import { GET_ACTIVITY } from 'graphql/secure/queries/activity.queries';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { IActivity } from 'types/activity.types';
import { AvailableLanguages } from 'types/enums';

const useActivity = () => {
  const { id } = useParams<{ id: string }>();
  const { openDialog } = useDialog();

  const { data, loading, error } = useQuery<
    { activity: IActivity },
    {
      id: IActivity['id'];
      lang?: AvailableLanguages;
    }
  >(GET_ACTIVITY, {
    variables: {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      id: id!,
    },
    skip: !id,
  });

  const activity = data?.activity;

  const latestLog: Omit<ILogItem, 'title'> = useMemo(
    () => ({
      date: activity?.latestLog?.timestamp || new Date(),
      logo: activity?.latestLog?.company.logo?.url,
      author: `${activity?.latestLog?.user.firstName} ${activity?.latestLog?.user.lastName}`,
    }),
    [activity]
  );

  const handleEditActivity = (activity: IActivity) => {
    openDialog({
      type: 'ADD_EDIT_ACTIVITY',
      props: {
        activity,
        mode: 'edit-activity',
      },
    });
  };

  return { activity, latestLog, error, loading, handleEditActivity };
};

export default useActivity;
